// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/vor-accuracy-check.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/vor-accuracy-check/vor-accuracy-check.js';
import g1 from '../lessons/navigation/vor-accuracy-check/vor-radial-accuracy.js';

mount([g0, g1]);
